import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'shared-spin-loading',
  standalone: true,
  templateUrl: './spin-loading.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinLoadingComponent {
  // This param define spinner height and width in px
  size = input<number>(8);
}
